/** Shared self-hosted ALTCHA solver for auth and public runtime consumers. */
export async function solveCaptchaChallenge(
  input: unknown,
  signal?: AbortSignal
): Promise<string> {
  signal?.throwIfAborted();
  if (!input || typeof input !== 'object')
    throw new Error('Invalid CAPTCHA challenge');
  const challenge = input as Record<string, unknown>;
  const { algorithm, salt, signature, maxnumber } = challenge;
  const hash = challenge.challenge;
  if (
    algorithm !== 'SHA-256' ||
    typeof hash !== 'string' ||
    !/^[a-f0-9]{64}$/i.test(hash) ||
    typeof salt !== 'string' ||
    !salt ||
    typeof signature !== 'string' ||
    !signature ||
    typeof maxnumber !== 'number' ||
    !Number.isSafeInteger(maxnumber) ||
    maxnumber < 0 ||
    maxnumber > 500_000
  )
    throw new Error('Invalid CAPTCHA challenge');
  const { solveChallenge } = await import('altcha-lib');
  signal?.throwIfAborted();
  const { promise, controller } = solveChallenge(
    hash,
    salt,
    algorithm,
    maxnumber,
    0
  );
  const abort = () => controller.abort();
  signal?.addEventListener('abort', abort, { once: true });
  try {
    const solution = await promise;
    signal?.throwIfAborted();
    if (!solution) throw new Error('ALTCHA challenge solving failed');
    return btoa(
      JSON.stringify({
        algorithm,
        challenge: hash,
        number: solution.number,
        salt,
        signature,
      })
    );
  } finally {
    signal?.removeEventListener('abort', abort);
  }
}
